import namespace from '@/store/namespace'
export default namespace('CorreoAlternativo',{
    getters:[
        
    ],
    actions:[
        'RegistrarCorreoA',
        'ActualizarCorreoA',
        'EliminarCorreoA',
        'ListarCorreoA'
    ],
    mutations:[
       
    ]
})